import goalPostsGetters from "./getters.js";
import goalPostsMutations from "./mutations.js";
import goalPostsActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      goalPostsTimestamp: null,
      companyReports: [],
      companyGoals: [],
      departmentGoals: [],
      userReports: [],
      userGoals: [],
    };
  },
  getters: goalPostsGetters,
  mutations: goalPostsMutations,
  actions: goalPostsActions,
};
